import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import Tippy from '@tippyjs/react';
require('tippy.js/dist/tippy.css');
require('tippy.js/themes/light.css');

export default observer((props) => {
  const store = useLocalObservable(() => ({some_prop: ''}));
  useEffect(() => {
    // mount
    return () => {
      // unmount
    }
  }, []);

  return (
    <Tippy content={<div className="fs14 tal">{props.text}</div>} trigger={"manual"} visible={props.show} theme="light" placement="top-start">
      <div>{props.children}</div>
    </Tippy>
  )

});